export interface PopinModel {
	id: string
	open: boolean
}

export const INITIAL_AJOUT_SIGNATAIRE_POPIN: PopinModel = {
	id: 'ajout_signataire',
	open: false
}

export const INITIAL_AJOUT_SUIVEUR_POPIN: PopinModel = {
	id: 'ajout_suiveur',
	open: false
}

export const INITIAL_RETOUR_CREATION_POPIN: PopinModel = {
	id: 'retour_creation',
	open: false
}

export enum typeSignataire {
	Signataire = 'Signataire',
	Validateur = 'Validateur'
}

export enum typeAjout {
	Signataire = 'Signataire',
	Suiveur = 'Suiveur'
}

export enum methodeAuthentification {
	SMS = 'otp_sms',
	Email = 'otp_email'
}

export enum positionSignature {
	hautGauche = 'Haut gauche',
	hautcentree = 'Haut centrée',
	hautDroite = 'Haut droite',
	milieuGauche = 'Milieu gauche',
	milieuCentree = 'Milieu centrée',
	milieuDroite = 'Milieu droite',
	basGauche = 'Bas gauche',
	basCentree = 'Bas centrée',
	basDroite = 'Bas droite',
}